module.exports = __webpack_public_path__ + "static/media/employee_level_inactive.129da876.svg";